export default __webpack_public_path__ + "static/media/089-sint-maarten.049baf4c.svg";